import { ItemLineDTO } from '../domain/models';

export class CalculatorService {
  // calculates subtotal of all items (price * quantity)
  subTotal(items: ItemLineDTO[]): number {
    return items.reduce((acc, it) => acc + Number(it.product.unitPrice ?? 0) * Number(it.quantity ?? 0), 0);
  }

  // helper that returns simplified totals without VAT/discount/shipping
  totals(items: ItemLineDTO[]) {
    const sub = this.subTotal(items);
    return { subTotal: sub, grandTotal: sub };
  }
}
